import { NgModule } from '@angular/core';
import { StateSlice } from '../state-slice';
import { ActionReducer, StoreModule } from '@ngrx/store';
import { reducer } from './deliveries-reducer';
import { initialDeliveriesState } from './deliveries-state';
import { EffectsModule } from '@ngrx/effects';
import { DeliveriesEffects } from './deliveries-effects';
import { combineReducers, entityMetaReducer } from '@core/utils/state';
import { DeliveriesDataService } from '@core/data/api/delivery/deliveries-data.service';
import { DispatchDataService } from '@core/data/api/dispatch/dispatch-data.service';
import { DeliveriesConfigEffects } from './deliveries-config/deliveries-config.effects';
import { DispatchConfigEffects } from './dispatch-config/dispatch-config.effects';
import { DialogModule } from '@components/dialog/dialog.module';
import { PopComponentModule } from '@components/pop/pop.component.module';
import { DeliveriesSettingsEffects } from './delivery-settings/delivery-settings.effects';

@NgModule({
    imports: [
        StoreModule.forFeature(StateSlice.DELIVERY, (reducer as ActionReducer<any, any>), {
            initialState: initialDeliveriesState,
            metaReducers: [entityMetaReducer],
            reducerFactory: combineReducers
        }),
        EffectsModule.forFeature([
            DeliveriesEffects,
            DeliveriesConfigEffects,
            DispatchConfigEffects,
            DeliveriesSettingsEffects
        ]),
        DialogModule,
        PopComponentModule
    ],
    declarations: [],
    providers: [
        DeliveriesDataService,
        DispatchDataService
    ]
})
export class DeliveriesStateModule {}
